import translation from './../lang.js';

export default {
    importableMotorData: null,
    selectedFactory: localStorage.getItem('selectedFactory'),
    scopes: '_blank',
    users: [],
    currentLanguage: 'fr',
    langs: translation,
    casings: [
        'aluminium',
        'cast_iron',
        'atex'
    ],
    applications: [
        'centrifugal_ventilation',
        'axial_ventilation',
        'motor',
        'pumping'
    ],
    regulations: {
        'centrifugal_ventilation': [
            'drawing_beforehand_with_registers',
            'drawing_afterwards_with_registers',
            'drawing_beforehand_with_valves',
            'electronic_speed_variation',
            'no_adjustment'
        ],
        'axial_ventilation': [
            'blades_with_self_adjusting_interval',
            'drawing_afterwards',
            'electronic_speed_variation',
            'no_adjustment'
        ],
        'motor': [
            'no_adjustment'
        ],
        'pumping': [
            'by_pass',
            'throttle_valve',
            'coupler',
            'all_or_none',
            'electronic_speed_variation',
            'no_adjustment'
        ]
    },
    trad: {
        'centrifugal_ventilation': {
            'en': 'Centrifugal ventilation',
            'fr': 'Ventilation centrifuge'
        },
        'axial_ventilation': {
            'en': 'Axial ventilation',
            'fr': 'Ventilation axiale'
        },
        'pumping': {
            'en': 'Pumping',
            'fr': 'Pompage'
        },
        'motor': {
            'en': 'Motor',
            'fr': 'Moteur'
        },
        'by_pass': {
            'en': 'By-pass',
            'fr': 'By-pass'
        },
        'coupler': {
            'en': 'Coupler',
            'fr': 'Coupleur'
        },
        'drawing_beforehand_with_registers': {
            'en': 'Drawing beforehand with registers',
            'fr': 'Laminage amont par registres'
        },
        'drawing_beforehand_with_valves': {
            'en': 'Drawing beforehand with valves',
            'fr': 'Laminage amont par vantelles'
        },
        'drawing_afterwards': {
            'en': 'Drawing afterwards',
            'fr': 'Laminage aval'
        },
        'drawing_afterwards_with_registers': {
            'en': 'Drawing afterwards with registers',
            'fr': 'Laminage aval par registres'
        },
        'no_adjustment': {
            'en': 'No adjustment',
            'fr': 'Pas de réglage'
        },
        'blades_with_self_adjusting_interval': {
            'en': 'Blades with self-adjusting interval',
            'fr': 'Pâles à pas auto-réglables'
        },
        'all_or_none': {
            'en': 'All-or-None',
            'fr': 'T.O.R.'
        },
        'throttle_valve': {
            'en': 'Throttle valve',
            'fr': 'Vanne de laminage'
        },
        'electronic_speed_variation': {
            'en': 'Electronic speed variation',
            'fr': 'Variation électronique de vitesse'
        },
        'aluminium': {
            'en': 'Aluminium',
            'fr': 'Aluminium'
        },
        'cast_iron': {
            'en': 'Cast iron',
            'fr': 'Fonte'
        },
        'atex': {
            'en': 'ATEX',
            'fr': 'ATEX'
        },
        '+ variator': {
            'en': ' + variator',
            'fr': ' + variateur'
        },
        'current': {
            'en': 'implementation of a variator to the current engine',
            'fr': 'ajout d\'un variateur au moteur actuel'
        },
        'installation': {
            'en': 'setup motor',
            'fr': 'installation moteur'
        }
    },
    img: {
        'centrifugal_ventilation' : 'ventilateur_centrifuge_visuel_big.jpg',
        'axial_ventilation' : 'ventilateur-axial-helicoide-moyenne-pression-003825810-product_zoom.jpg',
        'motor' : 'img-motor.jpg',
        'pumping' : 'pompe centrifuge.jpg',
        'drawing_beforehand_with_registers': 'centrifuge-amont-registre.png',
        'drawing_afterwards_with_registers': 'centrifuge-aval-registre.png',
        'drawing_beforehand_with_valves': 'centrifuge-amont-ventelles.png',
        'electronic_speed_variation': 'variation_electronique_de_vitesse.png',
        'no_adjustment': '',
        'blades_with_self_adjusting_interval': 'axial-pales.png',
        'drawing_afterwards': 'centrifuge-aval-registre.png',
        'by_pass': 'bypass.png',
        'throttle_valve': 'etranglement.png',
        'coupler': 'couplage-hydraulique.png',
        'all_or_none': 'tout-ou-rien.png'

    },
    simulation_error: {
        'incorrect_input': {
            'en': 'Wrong inputs. Please contact administrator for more information.',
            'fr': 'Mauvaises données d\'entrées. Veuillez contacter un administrateur pour plus d\'informations.'
        },
        'internal_error': {
            'en': 'Internal error. Please contact administrator.',
            'fr': 'Erreur interne. Veuillez contacter un administrateur.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/state.js